import { render, staticRenderFns } from "./QuotesCard.vue?vue&type=template&id=76b1f644&scoped=true"
import script from "./QuotesCard.vue?vue&type=script&lang=js"
export * from "./QuotesCard.vue?vue&type=script&lang=js"
import style0 from "./QuotesCard.vue?vue&type=style&index=0&id=76b1f644&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b1f644",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
